<template>
  <!-- 多选框组件封装 -->
  <van-checkbox-group v-model="checkIds">
    <van-cell-group>
      <van-cell v-for="ele in list" :key="ele.id">
        <template #title>
          <van-checkbox :name="ele.id" shape="square" icon-size="14px">
            <span class="color-box mar-rgt-10"
                  :style="`background-color:rgba(${ele.headerColor || '200,201,204'},0.35)`">{{ele.name[0]}}</span>
            <span class="custom-title">{{ele.name}}</span>
            <span v-show="extraKey" class="custom-title">（{{ele[extraKey] || "无"}}）</span>
          </van-checkbox>
        </template>
      </van-cell>
    </van-cell-group>
  </van-checkbox-group>
</template>

<script>
  export default {
    props: {
      selectedIds: Array,
      list: Array,
      extraKey: String,
    },
    data() {
      return {}
    },
    computed: {
      checkIds: {
        get: function () {
          return this.selectedIds || []
        },
        set: function (ids) {
          this.$emit('change-ids', ids)
        },
      },
    },
    methods: {}
  }
</script>

<style scoped>
</style>
